export default function Contact() {
  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);

    fetch(
      "https://docs.google.com/forms/d/e/YOUR_FORM_ID/formResponse",
      {
        method: "POST",
        mode: "no-cors", // Google requires this
        body: data,
      }
    ).then(() => {
      alert("Thank you for your message!");
      form.reset();
    });
  };

  return (
    <section className="contact-section" id="contact">
      <h2>Contact Us</h2>
      <p>
        Let’s talk about how Ellentra Technologies can help you build, scale, or
        transform your digital ideas.
      </p>

      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          name="entry.1253284942" 
          placeholder="Your Name"
          required
        />
        <input
          type="email"
          name="entry.428827748" 
          placeholder="Your Email"
          required
        />
        <textarea
          name="entry.176533274" 
          placeholder="Your Message"
          required
        />
        <button type="submit">Send Message</button>
      </form>
    </section>
  );
}
